import { Box, Flex, Text, useBreakpoint } from "@chakra-ui/react";
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import config from '@config';
import ContentArea from "./ContentArea";
import Link from "next/link";



import { keyframes } from '@emotion/react';

const marquee = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

import { useBreakpointValue } from '@chakra-ui/react';
import { modifyDatoImgUrlToStatic } from "./utils";

let BestSeller = ({ sectionContent }) => {

    const images = useBreakpointValue({ base: [...sectionContent, ...sectionContent], xl: sectionContent });

    return (
        <Box
            bgColor={'#FFFFFF'}
            py={{ base: '15px', md: '20px' }}
            overflowX={{ base: 'hidden', md: 'visible' }}
        >
            <Box
                width="100%"
                overflow="hidden"
                position="relative"
            >
                <Flex
                    as="div"
                    flexDir={'row'}
                    gap={{ base: '30px', md: '50px', xl: '45px' }}
                    minWidth={{ base: 'max-content', xl: 'auto' }}
                    animation={{ base: `${marquee} 10s linear infinite`, xl: 'none' }}
                    justifyContent={'center'}
                >
                    {images.map((item, index) => {
                        if (item?.image?.url) {
                            return (
                                <Box key={index + '-' + item?.image?.url} minW={{ base: 'auto', md: 'auto' }}>
                                    <LazyLoadImageComponent src={modifyDatoImgUrlToStatic(item?.image?.url)} alt="" />
                                </Box>
                            )
                        }
                        return null;
                    })}
                </Flex>
            </Box>
        </Box>
    )
}


export default BestSeller;